<script lang="ts" setup>
import BaselineCard from '../components/card/baselineCard.vue';

// ================================
// Composables
// ================================
const { baselines, loadingBaselinesList, loadingBaselinesListPerformance } = storeToRefs(baselineStore());
const { clearBaselineData } = baselineStore();
const { getBaselines } = baselineRepository();

// ================================
// Lifecycle
// ================================
onMounted(async () => {
  await getBaselines();
});

// ================================
// Methods
// ================================
const navigateToCreateBaseline = () => {
  clearBaselineData();
  navigateTo({
    name: 'baseline-create-energy-use',
  });
};
</script>
<template>
  <ui-page :loading="loadingBaselinesList" :title="$t('baseline.baselines')">
    <template #header-actions>
      <u-button leading-icon="i-lucide-plus" @click="navigateToCreateBaseline">
        {{ $t('baseline.new_baseline') }}
      </u-button>
    </template>
    <div class="max-w-[1400px] grid grid-cols-3 gap-4 row-auto w-full group group-hover:cursor-pointer">
      <baseline-card
        v-for="baseline in baselines"
        :id="baseline.id"
        :key="baseline.id.toString()"
        :loading="loadingBaselinesList"
        :performance-loading="loadingBaselinesListPerformance"
        :is-draft="!baseline.finalized_at"
        :baseline-data="{
          areaId: baseline.area_id,
          variables: baseline.model.variables.map((variable) => variable.name),
          overallR2: baseline.r_squared ? Number(baseline.r_squared) : null,
          last3MonthsR2: baseline.adj_r_squared ? Number(baseline.adj_r_squared) : null,
        }"
        :performance-data="null"
      />
    </div>
  </ui-page>
</template>
